export const THEME_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const themeModeOptions = [
  { labelKey: 'WORD_THEME_LIGHT', value: THEME_MODE.LIGHT },
  { labelKey: 'WORD_THEME_DARK', value: THEME_MODE.DARK },
];

export const isDarkThemeMode = (themeMode) =>
  !themeMode || themeMode === THEME_MODE.DARK;
